import React from 'react';

export const BENEFITS = [
  {
    key: 'warranty',
    icon: '/check-warranty.svg',
    text: (
      <>
        1 Year
        <br />
        Warranty
      </>
    ),
  },
  {
    key: 'lifetime',
    icon: '/spark.svg',
    text: (
      <>
        Lifetime fitting
        <br />& cleaning
      </>
    ),
  },
  {
    key: 'protect',
    icon: '/shield-protect.svg',
    text: (
      <>
        Secure
        <br />
        payment
      </>
    ),
  },
  {
    key: 'delivery',
    icon: '/package-delivered.svg',
    text: (
      <>
        1 day free
        <br />
        delivery
      </>
    ),
  },
  {
    key: 'free-eye-test',
    icon: '/artwork.svg',
    text: (
      <>
        Free
        <br />
        eye test
      </>
    ),
  },
];
